<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', maxWidth: '500px' }"
  styleClass="create-cliente-dialog"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-building dialog-icon"></i>
        <h2>Nuovo Cliente</h2>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
    <div class="form-container">
      <!-- Campo Ragione Sociale -->
      <div class="form-field">
        <label for="ragioneSociale">
          Ragione Sociale
          <span class="required">*</span>
        </label>
        <input
          id="ragioneSociale"
          type="text"
          pInputText
          [(ngModel)]="ragioneSociale"
          placeholder="Inserisci la ragione sociale"
          [style]="{ width: '100%' }"
          [disabled]="saving"
          (keydown.enter)="isFormValid() && saveCliente()"
        />
        <small class="p-error" *ngIf="ragioneSociale.trim() && clienteEsiste()">
          Esiste già un cliente con questa ragione sociale
        </small>
        <small class="p-help-text" *ngIf="ragioneSociale.trim() && !clienteEsiste()">
          ✓ Ragione sociale disponibile
        </small>
      </div>

      <!-- Campo Tipologia Cliente -->
      <div class="form-field">
        <label for="tipologiaCliente">
          Tipologia Cliente
          <span class="required">*</span>
        </label>
        <p-dropdown
          id="tipologiaCliente"
          [options]="tipologieOptions"
          [(ngModel)]="tipologiaCliente"
          optionLabel="label"
          optionValue="value"
          placeholder="Seleziona tipologia"
          [style]="{ width: '100%' }"
          [disabled]="saving"
          [appendTo]="'body'"
          [overlayOptions]="{ baseZIndex: 2200000 }"
        >
          <ng-template let-option pTemplate="item">
            <div class="tipologia-dropdown-item">
              <span class="material-symbols-outlined tipologia-icon" [class.icon-pubblico]="option.value === 'PUBBLICO'" [class.icon-privato]="option.value === 'PRIVATO'">
                {{ option.icon }}
              </span>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
          <ng-template let-option pTemplate="selectedItem">
            <div class="tipologia-selected-item" *ngIf="option">
              <span class="material-symbols-outlined tipologia-icon" [class.icon-pubblico]="option.value === 'PUBBLICO'" [class.icon-privato]="option.value === 'PRIVATO'">
                {{ option.icon }}
              </span>
              <span>{{ option.label }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeDialog()"
        [disabled]="saving"
      ></button>
      <button
        pButton
        type="button"
        label="Crea Cliente"
        icon="pi pi-check"
        class="p-button-primary"
        (click)="saveCliente()"
        [disabled]="!isFormValid() || saving"
        [loading]="saving"
      ></button>
    </div>
  </ng-template>
</p-dialog>
